{
  "folders": {
    "actions": {
      "rename": "Renommer",
      "move_to": "Déplacer vers",
      "create_workspace": "Créer un espace de travail",
      "create_folder": "Créer un dossier",
      "delete": "Supprimer"
    },
    "forms": {
      "folder_name": "Nom du dossier",
      "enter_folder_name": "Entrez un nom de dossier",
      "my_folders": "Mes dossiers",
      "move_here": "Déplacer ici",
      "choose_folder": "Choisir un dossier"
    },
    "confirmations": {
      "delete_folder_title": "Supprimer le dossier?",
      "delete_folder_content": "Êtes-vous sûr de vouloir supprimer ce dossier? Vous ne pouvez pas annuler cette action.",
      "move_workspace": "Déplacer l'espace de travail"
    },
    "errors": {
      "unable_to_delete": "Impossible de supprimer"
    }
  },
  "members": {
    "team": "Équipe",
    "add_member": "Ajouter un membre",
    "add_team_members": "Ajouter des membres d'équipe",
    "team_member": "Membre de l'équipe",
    "who_add_placeholder": "Qui voulez-vous ajouter à cet espace de travail",
    "validation": {
      "select_team_member": "Veuillez sélectionner au moins un membre de l'équipe"
    },
    "confirmations": {
      "remove_member_title": "Êtes-vous sûr de vouloir supprimer ce membre?",
      "remove_member_content": "Cette personne n'aura plus accès à l'espace de travail."
    },
    "aria_labels": {
      "remove_member": "supprimer le membre {{email}}"
    }
  },
  "forms": {
    "title": "Titre",
    "folder": "Dossier",
    "icon": "Icône",
    "color": "Couleur",
    "firm_wide_access": "Autoriser l'accès à l'ensemble du cabinet",
    "read_only": "Lecture seule",
    "validation": {
      "title_required": "Veuillez entrer le titre du projet"
    },
    "placeholders": {
      "app_description": "De quoi parle votre application?",
      "workspace_description": "Comment allez-vous collaborer dans cet espace de travail"
    },
    "aria_labels": {
      "project_icon": "icône de projet {{index}}",
      "select_color": "sélectionner {{description}}"
    }
  },
  "actions": {
    "create_app": "Créer une application",
    "create_workspace": "Créer un espace de travail",
    "update_app": "Mettre à jour l'application",
    "update_workspace": "Mettre à jour l'espace de travail",
    "clone_app": "Cloner l'application",
    "clone_workspace": "Cloner l'espace de travail"
  },
  "status": {
    "loading_workspaces": "Chargement des espaces de travail",
    "search_no_results": "Impossible de trouver un/des espace(s) de travail avec le titre \"{{term}}\"",
    "no_workspaces": "Il n'y a pas d'espace de travail et de dossier pour vous, créez-en un maintenant"
  },
  "table": {
    "headers": {
      "name": "Nom",
      "owner": "Propriétaire",
      "created_at": "Créé le"
    }
  },
  "tooltips": {
    "firm_wide_workspace": "Espace de travail à l'échelle du cabinet"
  },
  "app": {
    "create_view_label": "Vue d'entreprise",
    "read_only": "Lecture seule",
    "no_access_message": "Vous n'avez pas accès à ce projet. Veuillez demander à la personne qui a partagé le lien avec vous de vous ajouter en tant que membre de l'équipe.",
    "search_no_results": "Impossible de trouver une/des application(s) avec le titre \"{{term}}\"",
    "no_apps_message": "Il n'y a pas d'application pour vous, créez-en une maintenant",
    "view_table": "Tableau",
    "view_grid": "Grille",
    "get_started_message": "Pour commencer, ajoutez votre première liste à partir du bouton + ci-dessus à gauche.",
    "unknown_tab_type": "Type d'onglet inconnu",
    "table": {
      "app_header": "Application",
      "workspace_header": "Espace de travail",
      "team_members_header": "Membres de l'équipe"
    },
    "team_share": "Équipe/Partager",
    "team": "Équipe"
  },
  "opportunities": {
    "form": {
      "header": "Opportunité",
      "company_label": "Sélectionner l'entreprise associée *",
      "company_placeholder": "Tapez pour rechercher une entreprise",
      "status_label": "Statut",
      "description_label": "Description",
      "description_placeholder": "Décrivez votre opportunité en une phrase",
      "tags_label": "Étiquettes",
      "proposed_fee_label": "Frais proposés",
      "date_label": "Date de l'opportunité",
      "date_placeholder": "date",
      "internal_owner_label": "Propriétaire interne",
      "internal_owner_placeholder": "Qui sera responsable de cette opportunité?",
      "team_involved_label": "Équipe impliquée",
      "team_involved_placeholder": "Équipe impliquée dans cette opportunité?",
      "referral_source_label": "Source de référence",
      "referral_source_placeholder": "Qui a référé cette opportunité?"
    },
    "workspace": {
      "link_button": "Lier l'espace de travail",
      "link_modal_label": "Espaces de travail",
      "link_validation": "Veuillez sélectionner un espace de travail",
      "unlink_title": "dissocier l'opportunité de l'espace de travail",
      "unlink_confirmation": "Cliquez sur confirmer pour dissocier l'opportunité de l'espace de travail",
      "unlink_confirm_title": "Êtes-vous sûr de vouloir dissocier cette opportunité?",
      "actions": {
        "update": "Mettre à jour",
        "unlink": "Dissocier"
      },
      "custom_fields": {
        "section_header": "Colonnes de l'espace de travail"
      }
    },
    "actions": {
      "add_opportunity": "Ajouter une opportunité",
      "add_column": "Ajouter une colonne"
    }
  },
  "more_actions": {
    "manage_columns": "Gérer les colonnes"
  }
}
